import { createFileRoute } from '@tanstack/react-router';
import { PricingPlanIndex } from '@/pages/billing/PricingPlanIndex';

export const Route = createFileRoute('/_authenticated/_app/settings/billing/pricing/')({
	component: PricingPlanIndex,
});
